import React from "react";

const Services = () => {
  return (
    <div className="container-xxl py-2">
      <div className="container py-5">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="text-secondary text-uppercase">Our Services</h6>
          <h1 className="mb-5">Explore Our Services</h1>
        </div>

        {/* Services Grid */}
        <div className="row g-4">
          {/* Service 1 */}
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/1.jpg"
                  alt="Air Freight"
                />
              </div>
              <h4 className="mb-3">Transport Services</h4>
              <p>
                services start from 2000 to 499999/- Price is depends on product
                and weightage and truck/ models price details and payment link
                will send after conform the order
              </p>
            </div>
          </div>

          {/* Service 2 */}
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/11.jpg"
                  alt="Ocean Freight"
                />
              </div>
              <h4 className="mb-3">Vehicle Rent services</h4>
              <p>
                services start from 20000 to 199999/- Rental Price is depends on
                product and weightage and truck/ models price details and
                payment link will send after conforming the order.
              </p>
            </div>
          </div>

          {/* Service 3 */}
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/6.jpg"
                  alt="Road Freight"
                />
              </div>
              <h4 className="mb-3">Shipping Services</h4>
              <p>
                Online booking please fill your details and requirements, price
                starts from INR: 2000 to 500000
              </p>
            </div>
          </div>

          {/* Service 4 */}
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/7.jpg"
                  alt="Train Freight"
                />
              </div>
              <h4 className="mb-3">Monthly Rental Services</h4>
              <p>
                Get a ride anytime, anywhere with our ride-sharing services. Our
                drivers are available 24/7 and our prices are affordable.
                Whether you need a ride to work or a night out with friends,
                we've got you covered.
              </p>
            </div>
          </div>

          {/* Service 5 */}
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/4.jpg"
                  alt="Customs Clearance"
                />
              </div>
              <h4 className="mb-3">All over indian Delivery Services</h4>
              <p>
                Need to get something delivered quickly? Our delivery services
                are fast and reliable. We can deliver anything from documents to
                packages, and our drivers will ensure that your items arrive
                safely and on time.
              </p>
            </div>
          </div>

          {/* Service 6 */}
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item p-4">
              <div className="overflow-hidden mb-4">
                <img
                  className="img-fluid"
                  src="/assets/img/trucks/9.jpg"
                  alt="Warehouse Solutions"
                />
              </div>
              <h4 className="mb-3">Interstate & Cross-City Transport</h4>
              <p>
                Reliable cross-city and interstate logistics using a fleet of
                small to large vehicles for all cargo needs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
